import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowRight, DollarSign } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";

export const CashSuccessPage = () => {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div className="App font-sans bg-white text-brand-charcoal antialiased">
      <Header />
      <main>
        <section className="pt-28 sm:pt-32 pb-24 bg-brand-cream min-h-[60vh] flex items-center">
          <div
            className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-10 text-center w-full"
            data-testid="cash-success"
          >
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-green/15 text-brand-green">
              <CheckCircle2 className="h-8 w-8" />
            </span>
            <h1 className="mt-6 font-display font-black text-3xl sm:text-4xl tracking-tight text-brand-charcoal">
              Cash Order Submitted.
            </h1>
            <p className="mt-3 text-[15px] text-brand-charcoal/70">
              Thanks — our team will start prepping your order. Please have exact
              change ready when the driver arrives (or when you pick up at 110-46
              Merrick Blvd).
            </p>
            <p className="mt-3 inline-flex items-center gap-2 text-[12.5px] font-bold text-brand-teal">
              <DollarSign className="h-4 w-4" />
              Payment collected at hand-off
            </p>
            {orderId && (
              <p className="mt-4 text-[11.5px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/55">
                Order Reference: {orderId}
              </p>
            )}
            <Link
              to="/"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-charcoal text-white px-5 py-3 text-[12px] font-bold uppercase tracking-[0.12em] hover:bg-brand-teal"
            >
              Back to Home <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default CashSuccessPage;
